import {createAction} from 'redux-actions'

export const fetch = createAction('FIRMWARE/APPLIANCE/FETCH')
export const receive = createAction('FIRMWARE/APPLIANCE/RECEIVE', appliances => ({appliances}))